import { EditContext, EditMode } from './types'

export const modes: Record<
    EditMode,
    {
        min: number
        max: number
        step: number
        default: number
        property?: keyof EditContext
    }
> = {
    crop: { min: 0, max: 0.95, step: 0.05, default: 0, property: 'zoom' },
    saturation: { min: 0, max: 200, step: 1, default: 100, property: 'saturation' },
    contrast: { min: 0, max: 200, step: 1, default: 100, property: 'contrast' },
    brightness: { min: 0, max: 200, step: 1, default: 100, property: 'brightness' },
    hue: { min: 0, max: 100, step: 1, default: 0, property: 'hue' },
}

export const setModeDefaults = (context: EditContext) => {
    for (const mode of Object.keys(modes) as EditMode[]) {
        // @ts-expect-error not sure how to fix this
        context[modes[mode].property] = modes[mode].default
    }
}
